module.exports = __webpack_public_path__ + "img/hamburger.db6d8fd4.svg";